<div class="recipe-list-page">

  <!-- Page Header -->
  <div class="page-hero">
    <div class="container hero-inner">
      <div class="hero-text">
        <h1 class="hero-title">Recipes</h1>
        <p class="hero-sub">Get inspired with our delicious and easy recipes that your family and friends will love you for. From healthy dinners to bakery afternoon delights, we've got some of the best recipes for every occasion.</p>
      </div>
      <div class="hero-illustration" aria-hidden="true">
        <img src="https://images.unsplash.com/photo-1495147466023-ac5c588e2e94?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=60" alt="pastry illustration" class="hero-deco-img">
      </div>
    </div>
  </div>

  <div class="container recipe-content">

    <!-- Filter Tags -->
    <div *ngIf="!isLoading" class="filter-tags">
      <button
        *ngFor="let tag of allTags()"
        class="tag-pill"
        [class.active]="selectedTag() === tag"
        (click)="selectTag(tag)">
        {{ tag }}
      </button>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state text-center">
      <div class="spinner"></div>
      <p>Loading recipes...</p>
    </div>

    <div *ngIf="!isLoading">
      <!-- Featured Recipe -->
      <div *ngIf="featuredRecipe() && selectedTag() === 'All'" class="featured-recipe">
        <a [routerLink]="['/recipes', featuredRecipe()!.id]" class="featured-inner">
          <div class="featured-image-wrap">
            <img [src]="getImgSrc(featuredRecipe()!.imageUrl)" [alt]="featuredRecipe()!.title" class="featured-img">
          </div>
          <div class="featured-info">
            <div class="featured-tags">
              <span *ngFor="let tag of featuredRecipe()!.tags" class="tag-badge">{{ tag }}</span>
            </div>
            <h2 class="featured-title">{{ featuredRecipe()!.title }}</h2>
            <p class="featured-desc">{{ featuredRecipe()!.description }}</p>
            <div class="featured-meta">
              <span>⏱ {{ featuredRecipe()!.prepTime }} Prep</span>
              <span>🍳 {{ featuredRecipe()!.cookTime }} Cook</span>
              <span>👤 Serves {{ featuredRecipe()!.servings }}</span>
            </div>
            <span class="view-recipe-link">View Recipe &rarr;</span>
          </div>
        </a>
      </div>

      <!-- Recipe Grid -->
      <div class="recipes-grid">
        <a *ngFor="let recipe of filteredRecipes()" [routerLink]="['/recipes', recipe.id]" class="recipe-card">
          <div class="card-image-wrap">
            <img [src]="getImgSrc(recipe.imageUrl)" [alt]="recipe.title" class="card-img">
            <div class="card-tags">
              <span *ngFor="let tag of recipe.tags.slice(0, 2)" class="tag-badge small">{{ tag }}</span>
            </div>
          </div>
          <div class="card-body">
            <h3 class="card-title">{{ recipe.title }}</h3>
          </div>
        </a>
      </div>

      <div *ngIf="filteredRecipes().length === 0" class="empty-state text-center">
        <p>No recipes found for "{{ selectedTag() }}".</p>
      </div>
    </div>

  </div>
</div>
